import { IS_COOKIEBOT_ENABLED } from 'core/components/CookiebotScript/CookiebotScript';
import type { CookieConsentState } from 'core/components/CookiebotProvider/context';
import { pushToDataLayer } from './dataLayer';

export const COOKIE_CONSENT_STATISTICS_EVENT = 'cookie_consent_statistics';
export const COOKIE_CONSENT_MARKETING_EVENT = 'cookie_consent_marketing';

function updateGoogleConsentMode(consent: CookieConsentState): void {
    if (typeof window === 'undefined') {
        return;
    }

    const consentUpdate = {
        analytics_storage: consent.statistics ? 'granted' : 'denied',
        ad_storage: consent.marketing ? 'granted' : 'denied',
        ad_user_data: consent.marketing ? 'granted' : 'denied',
        ad_personalization: consent.marketing ? 'granted' : 'denied',
        functionality_storage: consent.preferences ? 'granted' : 'denied',
        personalization_storage: consent.preferences ? 'granted' : 'denied',
    };

    if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', consentUpdate);
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(['consent', 'update', consentUpdate]);
}

// Cookiebot fires both `CookiebotOnConsentReady` and `CookiebotOnConsentChange`
// for a single consent decision, and CookiebotProvider also invokes the handler
// directly when Cookiebot is already initialised. Without these guards each
// consent event would be pushed multiple times per page load, firing every base
// pixel tag in GTM two or three times.
let hasPushedStatisticsConsent = false;
let hasPushedMarketingConsent = false;

/** Sync Cookiebot categories to Google Consent Mode and GTM consent triggers. */
export function pushCookiebotConsentToDataLayer(
    consent: CookieConsentState,
): void {
    if (!IS_COOKIEBOT_ENABLED || typeof window === 'undefined') {
        return;
    }

    updateGoogleConsentMode(consent);

    if (consent.statistics && !hasPushedStatisticsConsent) {
        hasPushedStatisticsConsent = true;
        pushToDataLayer(COOKIE_CONSENT_STATISTICS_EVENT, {
            cookie_consent_statistics: true,
        });
    }

    if (consent.marketing && !hasPushedMarketingConsent) {
        hasPushedMarketingConsent = true;
        pushToDataLayer(COOKIE_CONSENT_MARKETING_EVENT, {
            cookie_consent_marketing: true,
        });
    }
}
